import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import SliderRiskAnglesLevels from './CreateAlert.StepOne.SliderRiskAnglesLevels';
import {isEqual} from 'lodash';

export default class RiskAngleLevels extends Component {

    constructor(props) {
        super(props);

        this.defaultRiskAngles = {
            political: 3,
            economic: 3,
            social: 3,
            technological: 3,
            legal: 3,
            environmental: 3
        };

        //if the riskAngles are all maxed by default, activate the All risk angles radio
        this.state = {
            selectedRiskAnglesOption: isEqual(this.defaultRiskAngles, this.props.data.riskAngles)
                ? 'all-angles' : 'custom-settings'
        };

        this.changeRiskAngleSelectedRadio = this.changeRiskAngleSelectedRadio.bind(this);
        this.changeRiskAnglesSliders = this.changeRiskAnglesSliders.bind(this);
    }

    changeRiskAngleSelectedRadio(event) {
        this.setState({selectedRiskAnglesOption: event.target.value});
        this.props.saveData({'riskAngles': this.defaultRiskAngles});
        this.props.validateSliderLevels();
    }

    changeRiskAnglesSliders(riskAngle) {
        let newRiskAngles = Object.assign({}, this.props.data.riskAngles, riskAngle);
        this.props.saveData({'riskAngles': newRiskAngles});
        this.props.validateSliderLevels();
    }

    render() {

        return (
            <div className='risk-angles-levels'>

                <div className='risk-angle-sliders-disclaimer'><FormattedMessage
                    id='Alerts_Create_UIText_name.step1.riskAnglesSection.info'/></div>

                <p className="risk-angles-levels__settings">

                        <span className="settings-option">
                            <input id="risk-angles-settings-all"
                                   type="radio"
                                   name="risk-angles-settings"
                                   value="all-angles"
                                   checked={this.state.selectedRiskAnglesOption === 'all-angles'}
                                   onChange={this.changeRiskAngleSelectedRadio}/>
                            <label htmlFor="risk-angles-settings-all">
                                <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.selectAll"/>
                            </label>
                        </span>

                    <span className="settings-option">
                            <input id="risk-angles-settings-custom"
                                   type="radio"
                                   name="risk-angles-settings"
                                   value="custom-settings"
                                   checked={this.state.selectedRiskAnglesOption === 'custom-settings'}
                                   onChange={this.changeRiskAngleSelectedRadio}/>
                            <label htmlFor="risk-angles-settings-custom">
                                <FormattedMessage id="RSS_Add_UIText_addRssFeed.riskAnglesLevels.customSettings"/>
                            </label>
                        </span>

                </p>

                {
                    this.state.selectedRiskAnglesOption === 'all-angles' ?
                        <div className='risk-select-all-info'><FormattedMessage
                            id='Alerts_Create_UIText_name.step1.riskAnglesSection.all'/></div>
                        :
                        <SliderRiskAnglesLevels changeRiskAnglesSliders={this.changeRiskAnglesSliders}
                                                errorMessage={this.props.errorMessage}
                                                riskAngles={this.props.data.riskAngles}/>
                }

            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/StepOneComponents/CreateAlert.StepOne.RiskAngleLevels.jsx